import React, { Component } from 'react'
import QRCode from 'qrcode.react'
import { Row, Col, Breadcrumb, Spin, Button, Divider, Tag, Modal, Radio, Popover } from 'antd'
import { Link, Route, Switch } from 'react-router-dom'
import moment from 'moment'
import { api, app, config } from "../../app"
import asyncComponent from '../../components/asyncComponent'
import Card from '../../components/Card'
import default_img from "../../assets/head_default_img.png"

const BarReact = asyncComponent(() => import('../../components/BarEcharts'))  //柱形图组件
/**
 * 统计图数据封装
 * @param data
 */
function packStatistics (dataInfo = []) {
    const categories = [], data = []
    dataInfo.forEach((item) => {
        categories.push(item.vname)
        data.push(item.count)
    })
    return { categories, data }
}

class Player extends Component {
    constructor (props) {
        super(props)
        const indexno = props.match.params.indexno
        const team_id = props.match.params.team_id
        this.state = {
            indexno: indexno,
            team_id: team_id,
            dataInfo: {},
            ppeInfo: {},
            data_loading: true,
            topData: [],
            ppeClassList: [],
            ppeList: [],
            statistics_btn: '1',
            statistics: {}
        }
    }

    componentDidMount () {
        this._isMounted = true
        this.dataSource(this.props.match.params.indexno)
        this.handlePeeTypes()
    }

    componentWillUnmount () {
        this._isMounted = false
    }

    setData = async (data) => {
        await app.setStateSync(this, data)
    }

    /**
     * 打开技能对话框
     * @param ppeInfo
     * @constructor
     */
    OpenPpeModal = async (ppeInfo) => {
        // let token = app.getToken();
        // if (!token) return;
        await this.setData({ ppe_visible: true, ppeInfo })
    }

    /**
     * 关闭技能对话框
     * @constructor
     */
    ClosePpeModal = () => {
        this.setState({ ppe_visible: false, ppeInfo: {} })
    }

    /**
     * 数据源
     */
    dataSource (indexno) {
        const _this = this, data = { indexno, team_id: this.state.team_id }
        if (indexno === app.getData('indexno')) {
            data.account = app.getData('account')
        }
        app.post(api.UserInfo, data).then(({ flag, data, msg }) => {
            if (flag === 1) {
                const statistics = {
                    team: packStatistics(data.teamRankingList)
                }
                _this.setOptions(statistics.team)
                _this.setState({ dataInfo: data, statistics, ppeList: data.ppe || [] })
            } else {
                app.alert(msg, "error")
            }
            _this.setState({ data_loading: false })
        })
    }

    setOptions ({ categories = [], data = [] }) {
        const chartOptions = {
            xAxis: {
                axisTick: {
                    show: false,
                },
                splitLine: { show: false },//去除网格线
                data: categories
            },
            yAxis: {
                axisTick: {
                    show: false,
                },
                splitLine: { show: false },//去除网格线
            },
            series: [{
                name: '救援数',
                type: 'bar',
                data: data,
                barWidth: 12,
                itemStyle: {
                    normal: {
                        color: (param) => {
                            const colors = categories.map((cate) => {
                                let color = "#AFCCE2"
                                if (cate === '我的' || cate === '他的' || cate === '她的') {
                                    color = "#0171C5"
                                }
                                return color
                            })
                            return colors[param.dataIndex]
                        }
                    }
                },
                label: {
                    normal: {
                        show: true,
                        color: '#444444',
                        fontSize: 12,
                        position: 'top'
                    }
                }
            }]
        }
        this.setState({ chartOptions, statistics_loading: false })
    }


    /**
     * 省级统计排行榜
     * @param indexno
     * @returns {{xAxis: {data: Array}, series: *[]}}
     */
    provinceRankingList () {
        const _this = this, statistics = this.state.statistics
        if (statistics.province) {
            this.setOptions(statistics.province)
            return
        }
        const indexno = this.state.indexno, data = { indexno }
        if (indexno === app.getData('indexno')) {
            data.account = app.getData('account')
        }
        app.post(api.ProvinceRankingList, data).then(({ flag, data, msg }) => {
            if (flag === 1) {
                statistics.province = packStatistics(data)
            } else {
                app.alert("网络服务忙~", "error")
            }
            _this.setState({ statistics })
            this.setOptions(statistics.province)
        })
    }


    /**
     * 技能分类
     * @returns {{xAxis: {data: Array}, series: *[]}}
     */
    async handlePeeTypes () {
        let { flag, data, msg } = await app.post(api.HomeClassList, data)
        if (flag === 1) {
            await this.setData({ ppeClassList: data })
        } else {
            app.alert(msg, "error")
        }
    }

    /**
     * 全国级级统计排行榜
     * @param indexno
     * @returns {{xAxis: {data: Array}, series: *[]}}
     */
    nationwideRankingList () {
        const _this = this, statistics = this.state.statistics
        if (statistics.nationwide) {
            this.setOptions(statistics.nationwide)
            return
        }
        const indexno = this.state.indexno, data = { indexno }
        if (indexno === app.getData('indexno')) {
            data.account = app.getData('account')
        }
        app.post(api.NationwideRankingList, data).then(({ flag, data, msg }) => {
            if (flag === 1) {
                statistics.nationwide = packStatistics(data)
            } else {
                app.alert("网络服务忙~", "error")
            }
            this.setOptions(statistics.nationwide)
            _this.setState({ statistics })
        })
    }

    /**
     * 排行按钮点击事件
     * @param key
     */
    handleTopBtn (key) {
        const statistics_btn = this.state.statistics_btn, statistics_loading = this.state.statistics_loading
        if (key === statistics_btn || statistics_loading) return false
        this.setState({ statistics_loading: true })
        const statistics = this.state.statistics
        switch (key) {
            case '1':
                this.setOptions(statistics.team)
                break
            case '2':
                this.provinceRankingList()
                break
            case '3':
                this.nationwideRankingList()
                break
        }
        this.setState({ statistics_btn: key })
    }

    componentWillReceiveProps (props) {
        const indexno = props.match.params.indexno
        if (indexno !== this.state.indexno) {
            this.setState({ data_loading: true })
            this.dataSource(indexno)
        }
    }

    /**
     * 无数据情况下跳转页面
     **/
    handleNoTo = (to, msg) => {
        if (app.getToken()) {
            this.props.history.push(to)
        } else {
            app.alert(msg, "warn", "15%")
        }
    }

    /**
     * 技能分类点击
     **/
    handlePpeClassChange = async (e) => {
        let { value } = e.target
        if (value === '0') {
            await this.setData({ ppeList: this.state.dataInfo.ppe })
        } else {
            let { flag, data, msg } = await app.post(api.PpeClassList, { id: value, indexno: this.state.indexno })
            if (flag === 1) {
                await this.setData({ ppeList: data })
            } else {
                app.alert(msg, "error")
            }
        }
    }

    render () {
        let { dataInfo, chartOptions, topData, data_loading, ppe_visible, ppeInfo, statistics_btn, ppeClassList, ppeList, indexno } = this.state,
            rescueYearCount = dataInfo.rescueYearCount || [],
            trainYearCount = dataInfo.trainYearCount || [],
            donateYearCount = dataInfo.donateYearCount || [],
            trainList = dataInfo.train || [],
            rescueList = dataInfo.rescue || [],
            donateList = dataInfo.donate || [],
            leaveInfo = dataInfo.leaveInfo || [],
            mallList = dataInfo.mall || [],
            volunteer_state = dataInfo.volunteer_state,
            province = app.getData('link_province'), teamno = app.getData('link_teamno'), teamno1 = null
        let dataNode = ''
        if (data_loading) {
            dataNode = (<Row type="flex" align="middle" justify="center" className="data_loading"><Spin
                tip="正在加载中..."></Spin></Row>)
        } else {
            dataNode = (
                <Row className="player_content" gutter={50}>
                    <Col span={12}>
                        <Card width="100%" title="基本信息"
                              style={{ padding: "30px 0", height: 450, overflowY: "auto", position: 'relative' }}>
                            <Row className="pc_top">
                                <Col span={6} className="tx-div">
                                    <img
                                        src={dataInfo.localpath ? (config.imgUrl + app.urlEncode(dataInfo.localpath)) : default_img}/>
                                </Col>
                                <Col span={18}>
                                    <Row className="pt_left">
                                        <Col span={24}>
                                            <Row className="ptl_item">
                                                <Col span={24} className="title">
                                                    {dataInfo.vname + " " + dataInfo.pinyin}
                                                    {
                                                        dataInfo.is_xcx === true ?
                                                            (<Tag color="#1890ff" style={{
                                                                fontSize: 14,
                                                                margin: '0 20px'
                                                            }}>已绑定小程序</Tag>) : null
                                                    }

                                                    <span
                                                        className="is_rz">（{dataInfo.ppeid === '存心工作证' ? '已认证队员' : '未认证队员'}）</span>
                                                </Col>
                                                {/*<Col span={12} className="content"></Col>*/}
                                            </Row>
                                            <Row className="item">
                                                <Col span={8} className="title">所属队伍</Col>
                                                <Col span={16} className="content">
                                                    {
                                                        dataInfo.teamname.map((team, i) => {
                                                            return (
                                                                <Link style={{ marginRight: 20 }} key={i}
                                                                      to={"/ranks/team/" + team.teamno}>{team.teamname}</Link>
                                                            )
                                                        })
                                                    }
                                                </Col>
                                            </Row>
                                            <Row className="item">
                                                <Col span={8} className="title">职务</Col>
                                                <Col span={16}
                                                     className="content">{dataInfo.teampositionname ? dataInfo.teampositionname.replace(/;/g, ' 、') : '无'}</Col>
                                            </Row>
                                            <Row className="item">
                                                <Col span={8} className="title">存心编号</Col>
                                                <Col span={16} className="content">{dataInfo.bsrno}</Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                            <Row className="pc_bottom">
                                <Row className="d_item">身份证号:<span>{dataInfo.idno || "暂无"}</span></Row>
                                <Row className="d_item">性别:<span>{dataInfo.sex || "暂无"}</span></Row>
                                <Row className="d_item">手机:<span>{dataInfo.mobile || "暂无"}</span></Row>
                                <Row className="d_item">出生年月:<span>{dataInfo.birthdate || "暂无"}</span></Row>
                                <Row className="d_item">护照号:<span>{dataInfo.passport || "暂无"}</span></Row>
                                <Row className="d_item">血型:<span>{dataInfo.bloodtype || "暂无"}</span></Row>
                                <Row className="d_item">入队时间:<span>{dataInfo.indate || "暂无"}</span></Row>
                                <Row className="d_item">过敏史:<span>{dataInfo.drughis || "暂无"}</span></Row>
                                <Row className="d_item">最后认证时间:<span>{dataInfo.rect || "暂无"}</span></Row>
                                <Row className="d_item">重大医疗史:<span>{dataInfo.medicalhis || "暂无"}</span></Row>
                            </Row>
                            {
                                volunteer_state === '4' ? <div className='leave-kaichu-img leave-img'/> :
                                    (volunteer_state === '5' ? <div className='leave-kaichu-img kaichu-img'/> : null)
                            }
                        </Card>
                    </Col>
                    <Col span={12}>
                        <Card width="100%" style={{ height: 450, overflowY: "auto" }} title="获得技能">
                            <div className="ppe-top">
                                <Radio.Group defaultValue="0" size="small" buttonStyle="solid"
                                             onChange={this.handlePpeClassChange}>
                                    <Radio.Button value="0">已获得</Radio.Button>
                                    {
                                        ppeClassList.map((cla, i) => {
                                            return (
                                                <Radio.Button value={cla.id} key={i}>{cla.names}</Radio.Button>
                                            )
                                        })
                                    }
                                </Radio.Group>
                            </div>
                            <div className="ppe-bottom">
                                {ppeList.length > 0 ? ppeList.map((p, i) => {
                                    return (
                                        <div className="ppe" key={i} onClick={() => this.OpenPpeModal(p)}
                                             title={p.names}>
                                            <img className="ppe-img" src={config.imgUrl + p.icon} alt=""/>
                                            <div className="ppe-name">{p.names}</div>
                                            {
                                                p.ppe_status !== '1' ? (
                                                    <div className="lock">
                                                        <i className="iconfont icon-suo"/>
                                                    </div>
                                                ) : null
                                            }
                                        </div>
                                    )
                                }) : (<p className="no-record">暂无获得技能~</p>)}
                            </div>
                        </Card>
                    </Col>
                    <Col span={12}>
                        <Card width="100%" style={{ padding: '0 25px' }} title={"排行榜"}>
                            <Row type="flex" className="s_top_btns">
                                <Col span={4} className="s_top_btn"><Button
                                    type={statistics_btn === '1' ? "primary" : ""} onClick={() => {
                                    this.handleTopBtn('1')
                                }}>队内排行</Button></Col>
                                <Col span={4} className="s_top_btn"><Button
                                    type={statistics_btn === '2' ? "primary" : ""} onClick={() => {
                                    this.handleTopBtn('2')
                                }}>省内排行</Button></Col>
                                <Col span={4} className="s_top_btn"><Button
                                    type={statistics_btn === '3' ? "primary" : ""} onClick={() => {
                                    this.handleTopBtn('3')
                                }}>全国排行</Button></Col>
                                <Col span={12} className="s_top_lable"><strong>80</strong></Col>
                            </Row>
                            {this.state.statistics_loading ?
                                <Row type="flex" align="middle" justify="center" className="data_loading"
                                     style={{ height: 400 }}><Spin
                                    tip="正在加载中..."></Spin></Row> : <BarReact option={chartOptions}/>}
                        </Card>
                    </Col>
                    <Col span={12}>
                        <Card width="100%" style={{ height: 484, padding: 10, overflowY: "auto" }} title={"离队/清退"}>
                            {
                                leaveInfo.map((leave, index) =>
                                    (
                                        <div key={index} className="leave-items">
                                            <div className="leave-item">
                                                <div className="li-title">离队时间</div>
                                                <div
                                                    className="li-content">{leave.outdate + " " + leave.leave_teamname}（离队）
                                                </div>
                                            </div>
                                            <div className="leave-item">
                                                <div className="li-title">离队原因</div>
                                                <div className="li-content">{leave.leave_reason}<Divider/></div>

                                            </div>
                                        </div>
                                    )
                                )
                            }
                            {
                                volunteer_state === "5" ?
                                    (
                                        <div className="leave-items">
                                            <div className="leave-item">
                                                <div className="li-title">清退时间</div>
                                                <div
                                                    className="li-content">{dataInfo.outdate || "无记录"}（清退）
                                                </div>
                                            </div>
                                            <div className="leave-item">
                                                <div className="li-title">清退原因</div>
                                                <div className="li-content">{dataInfo.leave_reason || "无"}</div>
                                            </div>
                                        </div>
                                    ) : null
                            }
                            {leaveInfo.length === 0 && volunteer_state !== "5" ?
                                (<div className="no-record">暂无记录</div>) : null}
                        </Card>
                    </Col>
                    <Col span={12}>
                        <Card width="100%" title="个人装备" className="auto_card" style={{ height: 278 }}>
                            {
                                mallList.length > 0 ?
                                    mallList.map((mall, index) => {
                                        return (
                                            <div key={index} className="card-item">
                                                <div className="mall-img">
                                                    <img src={config.imgUrl + mall.localpath} alt={mall.ppename}/>
                                                </div>
                                                <div style={{ marginTop: 20 }}>{mall.ppename}</div>
                                            </div>
                                        )
                                    })
                                    : (<div className="no-record"
                                            onClick={() => this.handleNoTo("/mall", "请先登录，方可前往商城进行购买哦~")}>暂无个人装备，赶快去购买吧</div>)
                            }
                        </Card>
                    </Col>
                    <Col span={12}>
                        <Card width="100%" style={{ padding: 20 }} title="捐赠记录">
                            <Row type="flex" style={{ width: '100%' }} className="total_count">
                                <Col span={20}>
                                    <Row style={{ width: '100%' }}>
                                        {
                                            donateYearCount.map((year, index) => {
                                                return (
                                                    <Col span={6} className="tc_item" key={index + 1}>
                                                        <div className="count"><span>{year.yearCount}</span>次</div>
                                                        <div className="year">{year.year}</div>
                                                    </Col>
                                                )
                                            })
                                        }
                                    </Row>
                                </Col>
                                <Col span={4} className="ckxq">
                                    <Link to={'/player/donation/' + this.state.indexno}>查看详情</Link>
                                </Col>
                            </Row>
                            <Row className="xqjl">
                                {
                                    donateList.map((item, index) => {
                                        return (<Row className="jlRow" key={index + 1}>
                                            <Col span={20}
                                                 className="title">{item.goods_name}</Col>
                                            <Col span={4}
                                                 className="data">{item.donate_time}</Col>
                                        </Row>)
                                    })
                                }
                            </Row>
                        </Card>
                    </Col>
                    <Col span={12}>
                        <Card width="100%" title="救援经历">
                            <Row type="flex" style={{ width: '100%' }} className="total_count">
                                <Col span={20}>
                                    <Row style={{ width: '100%' }}>
                                        {
                                            rescueYearCount.map((rescue, index) => {
                                                return (
                                                    <Col span={6} className="tc_item" key={index + 1}>
                                                        <div className="count"><span>{rescue.yearCount}</span>次</div>
                                                        <div className="year">{rescue.year}</div>
                                                    </Col>
                                                )
                                            })
                                        }
                                    </Row>
                                </Col>
                                <Col span={4} className="ckxq">
                                    <Link to={'/player/rescuelist/' + this.state.indexno}>查看详情</Link>
                                </Col>
                            </Row>
                            <Row className="xqjl">
                                {
                                    rescueList.map((rescue, index) => {
                                        return (<Row className="jlRow" key={index + 1}>
                                            <Col span={20}
                                                 className="title">{rescue.rescuename}</Col>
                                            <Col span={4}
                                                 className="data">{moment(rescue.startdate).format("YYYY-MM-DD")}</Col>
                                        </Row>)
                                    })
                                }
                            </Row>
                        </Card>
                    </Col>
                    <Col span={12}>
                        <Card width="100%" title="培训经历">
                            <Row type="flex" style={{ width: '100%' }} className="total_count">
                                <Col span={20}>
                                    <Row style={{ width: '100%' }}>
                                        {
                                            trainYearCount.map((train, index) => {
                                                return (
                                                    <Col span={6} className="tc_item" key={index + 1}>
                                                        <div className="count"><span>{train.yearCount}</span>次</div>
                                                        <div className="year">{train.year}</div>
                                                    </Col>
                                                )
                                            })
                                        }
                                    </Row>
                                </Col>
                                <Col span={4} className="ckxq">
                                    <Link to={'/player/trainlist/' + this.state.indexno}>查看详情</Link>
                                </Col>
                            </Row>
                            <Row className="xqjl">
                                {
                                    trainList.map((train, index) => {
                                        return (<Row className="jlRow" key={index + 1}>
                                            <Col span={20}
                                                 className="title">{train.trainame}</Col>
                                            <Col span={4}
                                                 className="data">{train.startdate ? moment(train.startdate).format("YYYY-MM-DD") : "无"}</Col>
                                        </Row>)
                                    })
                                }
                            </Row>
                        </Card>
                    </Col>
                </Row>
            )
        }
        return (
            <div className="ranks_content">
                <Row type="flex" justify="space-between" className="r_page_title">
                    <div>个人页面<span>Personal page</span></div>
                    <Popover placement="leftBottom"
                             content={<QRCode value={config.sharePlayerDoman + indexno}/>}
                             title="手机扫码分享" overlayStyle={{ textAlign: 'center' }}>
                        <Button type="primary" icon="share-alt">分享</Button>
                    </Popover>
                </Row>
                <Breadcrumb separator=">" className="r_right_breadcrumb">
                    <Breadcrumb.Item><Link to="/">首页</Link></Breadcrumb.Item>
                    {province ? (
                        <Breadcrumb.Item><Link to={"/ranks/pro/" + province}>队伍列表</Link></Breadcrumb.Item>) : ''}
                    {teamno1 ? (
                        <Breadcrumb.Item><Link to={"/ranks/detail/" + teamno1}>查看队伍</Link></Breadcrumb.Item>) : ''}
                    {teamno ? (
                        <Breadcrumb.Item><Link to={"/ranks/Players/" + teamno}>队员列表</Link></Breadcrumb.Item>) : ''}
                    <Breadcrumb.Item>个人页面</Breadcrumb.Item>
                </Breadcrumb>
                {dataNode}
                <Modal
                    visible={ppe_visible}
                    title={ppeInfo.names}
                    footer={null}
                    onCancel={this.ClosePpeModal}
                    className="review-skill-ppe-modal"
                    destroyOnClose={true}
                    centered={true}
                >
                    <div className="ppe-items">
                        {
                            ppeInfo.ppe_status === '1' ? (
                                <div>
                                    <Row className="ppe-item">
                                        <Col span={6} className="ppe-lable">发证机构：</Col>
                                        <Col span={17} offset={1}
                                             className="ppe-text">{ppeInfo.organization_name || '无'}</Col>
                                    </Row>
                                    <Row className="ppe-item">
                                        <Col span={6} className="ppe-lable">获证时间：</Col>
                                        <Col span={17} offset={1}
                                             className="ppe-text">{ppeInfo.datetime || '无'}</Col>
                                    </Row>
                                    <Row className="ppe-item">
                                        <Col span={6} className="ppe-lable">到期时间：</Col>
                                        <Col span={17} offset={1}
                                             className="ppe-text">{ppeInfo.is_long === '1' ? ppeInfo.expire_time : '长期 / 无有效期'}</Col>
                                    </Row>
                                </div>
                            ) : null
                        }
                        <Row className="ppe-item">
                            <Col span={6} className="ppe-lable">技能图标：</Col>
                            <Col span={17} offset={1} className="ppe-text">
                                <img src={config.imgUrl + ppeInfo.icon} alt="" className="ppe-img"
                                     width="60" height="60" title={ppeInfo.names}/></Col>
                        </Row>
                        <Row className="ppe-item">
                            <Col span={6} className="ppe-lable">备注：</Col>
                            <Col span={17} offset={1} className="ppe-text2">{ppeInfo.remarks || '无'}</Col>
                        </Row>
                    </div>
                </Modal>
            </div>
        )
    }
}

export default Player



// WEBPACK FOOTER //
// ./src/routes/playerInfo/Player.jsx